<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:48
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-10 20:09:39
 * @FilePath: \zhucai_user\src\pages\exam\result.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mb50">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb10 mt10"
    >
      <el-breadcrumb-item :to="{ path: '/course' }"
        >课程中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>课程考试</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="container" v-loading="isLoading">
      <div class="BGwhite pad30 gray1 flex radius8 mb20">
        <div class="top-left">
          <img src="@/assets/img/home/42.png" alt="" />
        </div>
        <div class="top-center flex1">
          <p class="name">{{ detail.PaperName }}</p>
          <p class="content">
            <span>题量：{{ detail.TotalNum }}</span>
            <span>时长：{{ detail.Duration }}分钟</span>
            <span>总分：{{ detail.TotalScore }}</span>
          </p>
        </div>
      </div>
      <div class="pad30 result">
        <div
          class="result-img"
          :class="detail.IsPass == true ? 'pass' : 'fail'"
        >
          <span class="GetScore">
            <span>{{ detail.GetScore }}</span>
            <p class="IsPass">
              考试结果：{{ detail.IsPass == true ? "合格" : "不合格" }}
            </p>
          </span>
        </div>
        <div class="top-center flex1">
          <p class="content">
            <span>题量：{{ detail.TotalNum }}</span>
            <span>用时：{{ detail.UseTime }}</span>
            <span>正确率：{{ detail.RightRate }}%</span>
          </p>
          <el-button
            v-if="detail.IsReExamBtn"
            type="primary"
            class="hand"
            @click="hand()"
            v-loading="isLoading"
            >重新考试</el-button
          >
        </div>
        <el-button type="primary" class="hand" @click="back">返 回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Exam_Create, Exam_GetResult } from "@/api/exam";
export default {
  name: "Exam_result",
  data() {
    return {
      detail: {},
      isLoading: false,
    };
  },
  watch: {
    "$route.query.ExamID"() {
      this.getDetail();
    },
  },

  methods: {
    back() {
      if (this.$route.query.FromType == 2) {
        this.$router.replace({
          path: "/member/taskDetail",
          query: {
            TaskID: this.$route.query.TaskID,
          },
        });
      } else {
        this.$router.replace({
          path: "/courseDetail",
          query: {
            CourseID: this.$route.query.CourseID,
          },
        });
      }
    },
    getDetail() {
      this.isLoading = true;
      Exam_GetResult({ ExamID: this.$route.query.ExamID })
        .then((res) => {
          this.detail = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    hand() {
      let data = {
        FromType: this.$route.query.FromType || 1,
        CourseID: this.$route.query.CourseID,
        PaperID: this.$route.query.PaperID,
      };
      if (this.$route.query.FromType == 2) {
        data = {
          FromType: 2,
          PaperID: this.$route.query.PaperID,
          TaskID: this.$route.query.TaskID,
        };
      }
      Exam_Create(data).then((res) => {
        this.$router.replace({
          path: "/exam/detail",
          query: {
            ExamID: res.data.ExamID,
            TaskID: this.$route.query.TaskID,
            PaperID: this.$route.query.PaperID,
            FromType:this.$route.query.FromType,
          },
        });
      });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped>
.red {
  background: #ffe6e8;
  border-radius: 4px;
  text-align: center;
  color: #eb525c;
  width: 57px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #eb525c;
    color: white;
  }
}
.top-left {
  width: 70px;
  height: 70px;
  margin-right: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
.top-center {
  .name {
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .content {
    font-size: 18px;
    color: #666666;
    span {
      margin-right: 50px;
    }
  }
}
.result {
  height: 588px;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
  .hand {
    margin-top: 20px;
    width: 144px;
    height: 52px;
    background: #1d79ff;
    border-radius: 6px;
    font-size: 18px;
    color: #ffffff;
  }
  .content {
    padding-left: 40px;
  }
  .result-img {
    margin: 50px auto;
    margin-bottom: 20px;
    width: 220px;
    height: 249px;
    background: url("~@/assets/img/home/46.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .GetScore {
      padding-top: 70px;
      font-weight: bold;
      font-size: 80px;
      color: #125feb;
      .IsPass {
        margin-top: 15px;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
  .fail {
    width: 220px;
    height: 249px;
    background: url("~@/assets/img/home/47.png") no-repeat;
    background-size: 100% 100%;
    .GetScore {
      font-weight: bold;
      font-size: 80px;
      color: #707070;
    }
  }
}
</style>
